
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContentSourceProviderContainer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentSourceProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providerKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"providerIconUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabledByRemind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabledByProvider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentWebhookUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bigPreviewWebhookUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productLongDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productShortDescription"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":302}};
    doc.loc.source = {"body":"query ContentSourceProviderContainer($uuid: String!) {\n  contentSourceProvider(organizationUUID: $uuid) {\n    title\n    providerKey\n    providerIconUrl\n    enabledByRemind\n    enabledByProvider\n    contentWebhookUrl\n    bigPreviewWebhookUrl\n    productLongDescription\n    productShortDescription\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ContentSourceProviderContainer"] = oneQuery(doc, "ContentSourceProviderContainer");
        
